export default function SamengesteldeGroep(options) {
  this.key = { key: options.key || options.key.key };
  this.naam = options.naam;
  this.omschrijving = options.omschrijving;
}
